import { Flex, Text } from "@simplybusiness/mobius";

export type PremiumProps = {
  isMonthly: boolean;
  hasInstallments?: string | boolean;
  installmentsAmount?: string;
  premium: string;
  offlinePurchaseOnly?: boolean;
};

export const Premium = (props: PremiumProps) => {
  const {
    isMonthly,
    hasInstallments,
    installmentsAmount,
    premium,
    offlinePurchaseOnly,
  } = props;

  const primaryAmountClasses = "mobius-quote-card__pricing-primary-amount";
  const periodSuffixClasses = "mobius-quote-card__pricing-period-suffix";

  if (!isMonthly) {
    return (
      <Flex alignItems="baseline">
        <Text className={primaryAmountClasses} data-testid="premium-amount">
          {premium}
        </Text>
        <Text
          elementType="span"
          variant="small"
          className={periodSuffixClasses}
        >
          {" / year"}
        </Text>
      </Flex>
    );
  }

  return hasInstallments && installmentsAmount ? (
    <Flex alignItems="baseline">
      <Text className={primaryAmountClasses} data-testid="installment-amount">
        {installmentsAmount}
      </Text>
      <Text className={periodSuffixClasses} elementType="span" variant="small">
        / month {offlinePurchaseOnly && " (estimated)"}
      </Text>
    </Flex>
  ) : (
    <Flex flexDirection="column">
      <Text
        variant="small"
        className="mobius-quote-card__pricing-unavailable-installment"
      >
        Monthly installments not available
      </Text>
      <div data-testid="unavailable-monthly-installment-amount">
        <Text elementType="span" className={primaryAmountClasses}>
          {premium}
        </Text>
        <Text
          elementType="span"
          variant="small"
          className={periodSuffixClasses}
        >
          {" / year"}
        </Text>
      </div>
    </Flex>
  );
};
